// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".explicit[data-v-02aa8128]{color:#fff;font-size:14px;font-weight:500;padding:4px 8px;margin-left:16px;line-height:14px;border-radius:4px;mix-blend-mode:normal;letter-spacing:-0.53px;border:1px solid rgba(255,255,255,0.8)}\n", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
